import { render } from "./Cropping.vue?vue&type=template&id=15c13f79&scoped=true"
import script from "./Cropping.vue?vue&type=script&lang=js"
export * from "./Cropping.vue?vue&type=script&lang=js"

import "./Cropping.vue?vue&type=style&index=0&id=15c13f79&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c13f79"]])

export default __exports__